import { useMemo } from 'react';
import { useLocale } from '../../context';
import { useSiteContent } from '../../context/SiteContentContext';
import {
  isMobileBottomNavActive,
  navigateMobileBottomItem,
  resolveMobileBottomNavItems,
} from '../../data/mobileBottomNav';
import { prefetchCasinoGameFeed, prefetchCasinoVendors } from '../../hooks/useCasinoGameFeed';

function prefetchCasinoTab() {
  import('../../pages/CasinoPage').catch(() => {});
  prefetchCasinoVendors('slots');
  prefetchCasinoGameFeed({
    lobby: 'slots',
    category: 'top',
    sort: 'popular',
    pageSize: 16,
  });
  prefetchCasinoGameFeed({
    lobby: 'slots',
    category: 'new',
    sort: 'popular',
    pageSize: 16,
  });
  prefetchCasinoGameFeed({
    lobby: 'slots',
    category: 'all',
    sort: 'popular',
    pageSize: 21,
  });
}

function TabButton({
  label,
  icon: Icon,
  active,
  badge,
  onClick,
  onPrefetch,
}) {
  return (
    <button
      type="button"
      className={`tab-bar__btn${active ? ' is-active' : ''}${badge > 0 ? ' has-badge' : ''}`}
      onClick={onClick}
      onPointerEnter={onPrefetch}
      onTouchStart={onPrefetch}
      aria-current={active ? 'page' : undefined}
    >
      <span className="tab-bar__icon-wrap">
        <span className="tab-bar__icon">
          <Icon />
        </span>
        {badge > 0 && (
          <span className="tab-bar__badge" aria-label={String(badge)}>{badge}</span>
        )}
      </span>
      <span className="tab-bar__caption">{label}</span>
      <span className="tab-bar__caption tab-bar__caption--bold">{label}</span>
    </button>
  );
}

export default function MobileBottomNav({
  activePage,
  accountSection,
  menuOpen = false,
  accountSheetOpen = false,
  accountSheetSection,
  sportFilter = 'all',
  hidden = false,
  onNavigate,
  onOpenMenu,
  onOpenAccount,
}) {
  const _locale = useLocale();
  const tr = _locale.t;
  const { nav } = useSiteContent();

  const items = useMemo(
    () => resolveMobileBottomNavItems(nav?.mobile_bottom),
    [nav?.mobile_bottom],
  );

  return (
    <div
      className={`tab-bar-container${hidden ? ' is-hidden' : ''}`}
      aria-label={tr('mobile.navigation')}
      aria-hidden={hidden || undefined}
    >
      <div className="tab-bar">
        <div className="tab-bar__wrap">
          {items.map((item) => (
            <TabButton
              key={item.id}
              label={item.label}
              icon={item.icon}
              active={isMobileBottomNavActive(item.pageId, {
                activePage,
                accountSection,
                menuOpen,
                accountSheetOpen,
                accountSheetSection,
                sportFilter,
              })}
              onClick={() => navigateMobileBottomItem(item.pageId, item, { onNavigate, onOpenMenu, onOpenAccount })}
              onPrefetch={item.pageId === 'casino' ? prefetchCasinoTab : undefined}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
